import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  emph: {
    color: t.primary,
  },
}))

export default useStyles
